var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// slide
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }
})(typeof window != "undefined" ? window : exports, function factory() {
  function Slide(beginMargin, endMargin, cellAlign) {
    (this || _global).beginMargin = beginMargin;
    (this || _global).endMargin = endMargin;
    (this || _global).cellAlign = cellAlign;
    (this || _global).cells = [];
    (this || _global).outerWidth = 0;
    (this || _global).height = 0;
  }

  let proto = Slide.prototype;

  proto.addCell = function (cell) {
    (this || _global).cells.push(cell);

    (this || _global).outerWidth += cell.size.outerWidth;
    (this || _global).height = Math.max(cell.size.outerHeight, (this || _global).height); // first cell stuff

    if ((this || _global).cells.length === 1) {
      (this || _global).x = cell.x; // x comes from first cell

      (this || _global).firstMargin = cell.size[(this || _global).beginMargin];
    }
  };

  proto.updateTarget = function () {
    let lastCell = this.getLastCell();
    let lastMargin = lastCell ? lastCell.size[(this || _global).endMargin] : 0;
    let slideWidth = (this || _global).outerWidth - ((this || _global).firstMargin + lastMargin);
    (this || _global).target = (this || _global).x + (this || _global).firstMargin + slideWidth * (this || _global).cellAlign;
  };

  proto.getLastCell = function () {
    return (this || _global).cells[(this || _global).cells.length - 1];
  };

  proto.select = function () {
    (this || _global).cells.forEach(cell => cell.select());
  };

  proto.unselect = function () {
    (this || _global).cells.forEach(cell => cell.unselect());
  };

  proto.getCellElements = function () {
    return (this || _global).cells.map(cell => cell.element);
  };

  return Slide;
});

export default exports;